import { LoadSurgicalOrderGuideAuthorization } from 'domain/usecases/surgical-order-guides/load-surgical-order-guides-authorization'
import { SurgicalOrderGuidesRepository } from 'repository/repositories/surgical-order-guides/surgical-order-guides-repository'

export class RemoteLoadSurgicalOrderGuideAuthorization
  implements LoadSurgicalOrderGuideAuthorization
{
  constructor(
    private readonly surgicalOrderGuidesRepository: SurgicalOrderGuidesRepository
  ) {}
  load(
    surgical_order_guide_id: number
  ): Promise<LoadSurgicalOrderGuideAuthorization.Model> {
    return this.surgicalOrderGuidesRepository.loadSurgicalOrderGuideAuthorization(
      surgical_order_guide_id
    )
  }
}
